import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const Ctx = createContext({ open: false, mode: 'login', openAuth: () => {}, closeAuth: () => {} });

export function AuthModalProvider({ children }){
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('login'); // 'login' | 'register'

  const openAuth = useCallback((m = 'login') => { setMode(m); setOpen(true); }, []);
  const closeAuth = useCallback(() => setOpen(false), []);

  const value = useMemo(() => ({ open, mode, openAuth, closeAuth }), [open, mode, openAuth, closeAuth]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAuthModal(){
  return useContext(Ctx);
}
